import React from 'react'
import Collapsable from './collapsable'
import MDText from './MDText'

const CollapsableCard = ({
  title,
  text,
  style,
  backgroundColor,
  children,
  ...props
}) => {
  return (
    <div style={{ background: backgroundColor, ...style }} {...props}>
      <Collapsable
        style={{ background: backgroundColor, marginBottom: 0 }}
        text={title}
        isCollapsed={true}
        hideCardEffects={true}
      >
        <div>
          {text && (
            <div
              style={{
                padding: '1rem 1.5rem',
                fontSize: '14px',
              }}
            >
              <MDText source={text} />
            </div>
          )}
          {children}
        </div>
      </Collapsable>
    </div>
  )
}

export default CollapsableCard



// WEBPACK FOOTER //
// ./src/components/shared/collapsableCard.js